<template>
  <full-screen :title="t('force-update.header')" :show-close="false">
    <div class="w-full h-full flex items-center justify-center relative">
      <div
        class="max-w-4xl flex flex-col gap-2 items-center justify-center text-n-0 text-center px-4"
      >
        <img src="@/assets/update.svg" class="w-44 h-44" />
        <div class="heading-2">
          {{ t('force-update.title') }}
        </div>
        <div class="font-text text-base text-n-100">
          {{ t('force-update.help') }}
        </div>
        <l-icon name="status" size="large" class="animate-spin mt-4" />
      </div>
    </div>
  </full-screen>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { onBeforeRouteLeave } from 'vue-router'

import { LIcon } from '@last/core-ui/paprika'

import FullScreen from '@/components/FullScreen.vue'
import updater from '@/updater'

const { t } = useI18n()

onMounted(() => {
  waitForUpdate()
})

async function waitForUpdate() {
  let updated = false
  while (!updated) {
    updated = await updater.checkForUpdates()
  }
}

onBeforeRouteLeave(() => false)
</script>
